export const processDateTime = (datetime: string) => {
  const formattedDate = new Date(datetime).toLocaleDateString("en-GB");
  const formattedTime = new Date(datetime).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${formattedDate}, ${formattedTime}`;
};
